module.exports = __webpack_public_path__ + "static/media/prendedores.b2c283cb.png";